import styled from '@olxui/core/dist/theme/styled';
import { P1, P3 } from '@olxui/core/dist/core/Typography';

export const AdCardWrapper = styled.div<{
    bookingSummary?: boolean;
    isMobile?: boolean;
}>`
    ${({ theme, bookingSummary }) => `
    display: flex;
    background: ${theme.colors['$01_white']};
    padding: ${bookingSummary ? theme.space[0] : theme.space[12]};
    margin: ${bookingSummary ? theme.space[0] : theme.space[16]};
    text-decoration: none;
    width: 100%;
    border: ${
        bookingSummary
            ? `1px solid ${theme.colors['borders-global-tertiary']}`
            : 'none'
    }
    
    `}
`;
export const AdCardImage = styled.div<{ bookingSummary?: boolean }>`
    min-width: 150px;
    margin-right: ${({ bookingSummary, theme }) =>
        bookingSummary ? theme.space[0] : theme.space[12]};
`;

export const AdCardDetails = styled.div<{ bookingSummary?: boolean }>`
    display: flex;
    flex-direction: column;
    width: auto;
    justify-content: ${({ bookingSummary }) =>
        bookingSummary ? 'space-around' : 'space-between'};
    padding: ${({ bookingSummary, theme }) =>
        bookingSummary ? theme.space[16] : theme.space[0]};
`;

export const AdCardDetailsTitle = styled(P1)<{
    bookingSummary?: boolean;
    isMobile?: boolean;
}>`
    ${({ theme, bookingSummary, isMobile }) => `
        font-weight: ${
            bookingSummary ? theme.fontWeights[400] : theme.fontWeights[800]
        };
        color: ${
            bookingSummary
                ? theme.colors['text-global-primary']
                : theme.colors.$07_charcoal
        };
        margin-bottom: ${theme.space[12]};
        ${
            bookingSummary &&
            `
        /* CSS magic to truncate lines */
        /* stylelint-disable-next-line property-no-vendor-prefix */
        -webkit-box-orient: vertical;
        /* stylelint-disable-next-line value-no-vendor-prefix */
        display: -webkit-box;
        -webkit-line-clamp: ${isMobile ? '3' : '4'};
        margin-bottom: auto;
        overflow: hidden;
        `
        }
    `}
`;
export const AdCardDetailsPrice = styled(P3)<{
    bookingSummary?: boolean;
}>`
    ${({ theme, bookingSummary }) => `
        font-weight: ${
            bookingSummary ? theme.fontWeights[800] : theme.fontWeights[500]
        };
        color: ${
            bookingSummary
                ? theme.colors['text-global-primary']
                : theme.colors.$07_charcoal
        };
        font-size: ${
            bookingSummary ? theme.fontSizes[18] : theme.fontSizes[14]
        };
        line-height: ${
            bookingSummary ? theme.lineHeights[20] : theme.lineHeights[18]
        };
    `}
`;
export const AdCardDetailsLocation = styled(P3)`
    color: ${({ theme }) => theme.colors.$06_gray};
`;
